<section class="content-header">

  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1 class="m-0 text-dark">Testing Capability List</h1>
      </div>

    </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</section>
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">

    <div class="card">

      <div class="card-body">

        <div class="container" *ngIf="isReadMode">
          <!-- <div class="row">
              <div class="col">
                <label> Search </label> <input [(ngModel)]="seachText" class="form-control">
  
              </div>
              <div class="col">
                <label>Select State:</label>
                <ng-select [items]="states" bindLabel="stateName" autofocus bindValue="stateCode"
                  [(ngModel)]="selectedState">
                </ng-select>
  
              </div>
            </div>
  <br>
            <div class="row">
  
              <div class="col"><input type="button" class="btn btn-primary"
                  value="Search" (click)="search()" /> &nbsp;&nbsp;&nbsp;
                  <input type="button" class="btn btn-primary"
                  value="Reset" (click)="reset()" /></div>
                  
            </div> -->
          <div class=" row">
            <div class="col-12">
              <p style="float:right">

                <input type="button" (click)="createRow()" value="Add / Update Testing Capability" class="btn btn-link">
              </p>
            </div>

          </div>
          <div class="row">

            <div class="col-md-12">
              <p style="float:right"><input type="button" class="btn btn-link" (click)="backOption()" class="btn btn-link" value="Back"></p>
            </div>
          </div>
          <div class="row">
            <table class="table table-striped table-hover table-bordered">
              <thead>
                <tr>
                  <th style="font-weight:bold">S. No.</th>
                  <th style="font-weight:bold">Vehicle No.</th>
                  <th style="font-weight:bold">Product Name</th>
                  <th style="font-weight:bold">Parameter Count</th>
                  <!-- <th style="font-weight:bold">Testing Type</th>
                  <th style="font-weight:bold">Testing Name</th>
                  <th style="font-weight:bold">Testing Mobile</th>
                  <th style="font-weight:bold">Testing Email</th>
                  <th style="font-weight:bold">Testing Id</th>
                  <th style="font-weight:bold">Action</th> -->
                </tr>

              </thead>
              <tbody>
                <tr
                  *ngFor="let testingSample of testingRecordData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                  <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                  <td>{{testingSample.vehicleNo}}</td>
                  <td>{{testingSample.productName}}</td>
                  <td>{{testingSample.paramCount}}</td>
                  <!--<td>{{testingSample.testingType}}</td>
                  <td>{{testingSample.testingName}}</td>
                  <td>{{testingSample.testingMobile}}</td>
                  <td>{{testingSample.testingemail}}</td>
                  <td>{{testingSample.testingId}}</td>
                   <td>
                    <input type="button" (click)="updateRow(testingSample)" [disabled]="role!='ADMIN'" value="Edit"
                      class="btn btn-primary">
                  </td> -->
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
          </div>
         

        </div>

        <div *ngIf="!isReadMode">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Add New Testing</h3>

              </div>
              <div class="card-body">
                Vehicle No. :
                   <ng-select [items]="userRecordData" bindLabel="userId"  bindValue="userId"
                      [(ngModel)]="selectedvehicle" [disabled]="true">
                    </ng-select>
                  
               Select Product: <ng-select [items]="products" bindLabel="productName" autofocus bindValue="productId"
                    [(ngModel)]="selectedproductId" (change)="productChanged()" [disabled]="!selectedvehicle" autofocus>
                    <ng-option [value]="null">Select Product</ng-option>
                </ng-select>
                <div *ngIf="selectedproductId!=undefined">

                  <br /><b>Selected Product: {{selectedProdctName}}</b>



                  <table class="table table-striped table-hover table-bordered">
                    <thead>
                      <tr>
                        <td style="font-weight:bold">Parameter</td>
                        <td style="font-weight:bold">Availability</td>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let parameter of parameters">
                        <td>{{ parameter.testParam }}</td>
                        <td> <input type="checkbox" [(ngModel)]="parameter.result"
                            id="{{parameter.mappingId}}" name="{{parameter.mappingId}}" />
                        </td>

                      </tr>

                    </tbody>
                  </table>
                  <!-- <b>Upload Report:</b>
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-3">
                                        <label class="btn btn-default p-0">
                                            <input type="file" #myInput multiple (change)="onFileSelect($event)" />
                                        </label>
                                    </div>
                                    <div class="col-4">
                                        <input type="button" value="Upload" class="btn btn-success btn-sm" (click)="submit()"
                                            [disabled]="!fileName">
                                    </div>
                                </div>
                                <div class="card mt-3" *ngIf="success==true">
                                    <div class="card-header">List of Files</div>
                                    <table class="table table-hover">
                                        <thead>
                                            <tr>
                                                <td style="font-weight:bold">Sr. No.</td>
                                                <td style="font-weight:bold">File Path</td>
                                                <td style="font-weight:bold">Actions</td>
                                           </tr>
                                        </thead>
        
                                        <tbody>
                                            <tr
                                                *ngFor="let file of fileInfos | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                                                <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                                                <td>{{ file.filename }}</td>
                                                <td>
                                                    <input type="button" (click)="deleteRow(file)" value="Delete"
                                                        class="btn btn-danger">
                                                </td>
                                             </tr>
                                        </tbody>
                                    </table>
                                 </div>
                            </div> -->


                  <br />
                  <div class="form-group" style="text-align: center;"><input type="submit" (click)="updateInsertData()" value="Submit"
                      class="btn btn-primary">&nbsp;&nbsp;&nbsp;
                      <input type="submit" (click)="showisReadMode()" value="Back"
                      class="btn btn-primary">
                    </div>
                      
                </div>


              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">Please Wait. </p>
</ngx-spinner>